import { notification } from "antd";

import { QueryKeys } from "@Constants";
import QuestionnaireService from "@Services/QuestionnaireService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PointsTypes } from "@Models/IPoints";

const useCMEReport = () => {
    // ** Hooks ** //
    const queryClient = useQueryClient();

    // ** Variables ** //
    const questionnaireService = new QuestionnaireService();

    // ** Report ** //
    /**
     * Create CME Points mutation
     */
    const {
        isLoading: isCreatingCMEPoints,
        isSuccess: hasCreatedCMEPoints,
        mutateAsync: createCMEPoints,
        reset: resetCMECreationStatus,
    } = useMutation(
        async (model: { activityInstanceIds: string[]; startedOn: string; endedOn: string }) => {
            const result = await questionnaireService.createPoints(model);
            return result;
        },
        {
            onSuccess: async (response) => {
                if (response.hasErrors) {
                    notification.error({
                        message: "Unable to create the certificate.",
                    });
                    return;
                }
                await queryClient.invalidateQueries([QueryKeys.PointsTableData, PointsTypes.CME]);
            },
        }
    );

    return {
        hasCreatedCMEPoints,
        isCreatingCMEPoints,

        createCMEPoints,
        resetCMECreationStatus,
    };
};

export default useCMEReport;
